module.exports = function createFragment(frag) {
  var res = [];
  if(frag.before) {
    res.push(frag.before);
  }
  if(frag.inside) {
    res.push(frag.inside);
  }
  if(frag.after) {
    res.push(frag.after);
  }
  return res.join("");
}



//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/tests/stubs/createFragment.js
// module id = 880
// module chunks = 6